import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const GCPLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1143_22276)">
                <path
                    d="M19.0312 12.7282H19.7181L21.6762 10.676L21.7722 9.80434C18.1278 6.43258 12.5659 6.79683 9.34879 10.6164C8.45493 11.6766 7.80718 12.9394 7.45288 14.3057C7.6706 14.2121 7.91266 14.1965 8.13984 14.2632L12.0561 13.5857C12.0561 13.5857 12.2548 13.2399 12.359 13.2611C14.1007 11.2557 17.0325 11.0218 19.0447 12.7282H19.0312Z"
                    fill="#EA4335"
                />
                <path
                    d="M24.466 14.3056C24.0157 12.568 23.0921 11.0061 21.8074 9.81274L19.0595 12.6927C20.2198 13.6862 20.8811 15.1843 20.8527 16.7547V17.2663C22.2036 17.2663 23.299 18.4143 23.299 19.8302C23.299 21.2461 22.2036 22.3941 20.8527 22.3941H15.9601L15.4719 22.9128V25.9884L15.9601 26.5H20.8527C24.3659 26.5284 27.2368 23.5662 27.2639 19.8841C27.2801 17.6476 26.2294 15.5556 24.466 14.3056Z"
                    fill="#4285F4"
                />
                <path
                    d="M11.0607 26.4676H15.9533V22.3631H11.0607C10.7118 22.3631 10.3683 22.2837 10.0505 22.1321L9.36359 22.356L7.39196 24.4083L7.22021 25.1283C8.32503 26.0041 9.67461 26.4747 11.0607 26.4676Z"
                    fill="#34A853"
                />
                <path
                    d="M11.0607 13.1534C7.54612 13.1746 4.71579 16.1779 4.73607 19.8615C4.74824 21.918 5.66374 23.854 7.22022 25.1069L10.0573 22.1334C8.82674 21.5509 8.27906 20.0315 8.83485 18.7418C9.39064 17.452 10.8403 16.878 12.0709 17.4605C12.6131 17.7171 13.0472 18.1735 13.2933 18.7418L16.1304 15.7683C14.9242 14.1129 13.0472 13.1449 11.0607 13.1534Z"
                    fill="#FBBC05"
                />
            </g>
            <defs>
                <clipPath id="clip0_1143_22276">
                    <rect width="22.5281" height="19.0047" fill="white" transform="translate(4.73596 7.49536)" />
                </clipPath>
            </defs>
        </svg>
    );
};
